/** Spring/JHipster-style list query params (?page=&size=&sort=&field.equals=). */
export const DEFAULT_LIST_SORT = 'id,desc';
/**
 * Builds query params for a paginated GET. When `input` is `undefined`, callers should omit
 * `{ params }` entirely (unpaginated / legacy list fetch).
 *
 * Array values become repeated keys when used with Axios `paramsSerializer: { indexes: null }`.
 */
export function buildSpringPageParams(input, options) {
    if (input === undefined) {
        return undefined;
    }
    const merged = {
        sort: options?.defaultSort ?? DEFAULT_LIST_SORT,
        page: options?.defaultPage ?? 0,
        size: options?.defaultSize ?? 10,
        ...input,
    };
    const out = {};
    for (const [key, value] of Object.entries(merged)) {
        if (value === undefined || value === null || value === '') {
            continue;
        }
        if (Array.isArray(value)) {
            const arr = value.filter(v => v !== undefined && v !== null && v !== '');
            if (arr.length) {
                out[key] = arr;
            }
            continue;
        }
        out[key] = value;
    }
    return out;
}
